import { alpha } from "@mui/material/styles";
import { getPublicSiteSx } from "../public-site/publicSiteStyles";

export function getMatchPageSectionSx(theme) {
  const publicSiteSx = getPublicSiteSx(theme);

  return {
    sectionPanel: {
      ...publicSiteSx.card,
      p: { xs: 2, md: 3 },
      borderRadius: "24px",
      background:
        "linear-gradient(180deg, rgba(18,18,18,0.94) 0%, rgba(18,18,18,0.84) 100%)",
      border: "1px solid rgba(255,255,255,0.08)",
      boxShadow: "0 24px 60px rgba(0,0,0,0.34)",
      backdropFilter: "blur(14px)",
    },
    sectionEyebrow: {
      color: "#E8A33D",
      fontSize: "0.76rem",
      fontWeight: 700,
      letterSpacing: "0.12em",
      textTransform: "uppercase",
      mb: 1,
    },
    sectionTitle: {
      fontSize: { xs: "1.3rem", md: "1.75rem" },
      fontWeight: 800,
      color: "#ffffff",
      mb: 0.75,
    },
    sectionBody: {
      color: "rgba(255,255,255,0.72)",
      fontSize: "0.95rem",
      lineHeight: 1.65,
    },
    divider: {
      borderColor: "rgba(255,255,255,0.08)",
    },
    teamCard: {
      p: { xs: 2, md: 2.5 },
      borderRadius: "20px",
      backgroundColor: "rgba(255,255,255,0.03)",
      border: "1px solid rgba(255,255,255,0.08)",
    },
    metricCard: {
      p: 1.25,
      borderRadius: "16px",
      backgroundColor: "rgba(255,255,255,0.025)",
      border: "1px solid rgba(255,255,255,0.06)",
    },
    metricLabel: {
      color: "rgba(255,255,255,0.62)",
      fontSize: "0.78rem",
      fontWeight: 600,
      letterSpacing: "0.04em",
      textTransform: "uppercase",
    },
    metricValue: {
      color: "#ffffff",
      fontSize: "1rem",
      fontWeight: 700,
    },
    progressTrack: {
      mt: 0.75,
      height: 8,
      borderRadius: 999,
      backgroundColor: "rgba(255,255,255,0.08)",
      "& .MuiLinearProgress-bar": {
        borderRadius: 999,
      },
    },
    neutralBadge: {
      borderRadius: "999px",
      color: "#ffffff",
      fontWeight: 700,
      backgroundColor: "rgba(255,255,255,0.06)",
      border: "1px solid rgba(255,255,255,0.08)",
    },
    tablePaper: {
      backgroundColor: alpha("#0f0f10", 0.88),
      border: "1px solid rgba(255,255,255,0.08)",
      boxShadow: "none",
      overflow: "hidden",
    },
    emptyState: {
      p: { xs: 2, md: 3 },
      borderRadius: "18px",
      backgroundColor: "rgba(255,255,255,0.025)",
      border: "1px solid rgba(255,255,255,0.06)",
      color: "rgba(255,255,255,0.72)",
    },
  };
}
